import { render } from "./About-page.vue?vue&type=template&id=b5363192"
import script from "./About-page.vue?vue&type=script&lang=js"
export * from "./About-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__